export enum CatalogMigrationStepEnum {
  Upload = 1,
  Distribution = 2,
  Merge = 3,
}
